import { Component, OnInit } from '@angular/core';
import { CoreCustomPage } from '../../shared/core-custom-page.decorator';
import { CorePageBaseComponent } from '../../shared/core-page-base.component';

@CoreCustomPage('standard')
@Component({
  selector: 'cu-standard-page',
  templateUrl: './standard-page.component.html',
  standalone: false
})
export class StandardPageComponent extends CorePageBaseComponent implements OnInit {
  public ngOnInit(): void {
    /// Adding empty implementation to avoid onload method calling multiple times
  }
}
